/* eslint-disable no-redeclare */
import { z } from 'zod';

export const HtmlText = z.string();

export type HtmlText = z.infer<typeof HtmlText>;

declare const __sanitizedHtmlBrand: unique symbol;

/**
 * HTML that has been processed through the xss sanitizer and is safe to pass
 * to `dangerouslySetInnerHTML`. Only obtainable via `sanitizeHtml()` from
 * `@hc-frontend/core-utils-format`, preventing accidental rendering of
 * unsanitized remote or user-supplied HTML.
 */
export type SanitizedHtml = string & { readonly [__sanitizedHtmlBrand]: never };
